export const CLOSE_COUNTRY_FILTER = "CLOSE_COUNTRY_FILTER";
export const OPEN_COUNTRY_FILTER = "OPEN_COUNTRY_FILTER";
